import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowRight, FiShoppingBag, FiPlusCircle, FiBarChart2, FiGrid } from 'react-icons/fi';
import Logo from '../Assets/images/logo.png';
import { getCookie } from "../Helpers/Utils";

const StaffWelcome = () => {
    const navigate = useNavigate();

    // Cookie-la irundhu user data-va edukkurom
    const userData = getCookie("user_data") ? JSON.parse(getCookie("user_data")) : null;
    const userName = userData?.name || "User";
    const userRole = userData?.role || "staff"; // Role-ah check panna (admin/staff)

    const styles = {
        container: {
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8fafc',
            textAlign: 'center',
            padding: '20px',
            fontFamily: 'Inter, sans-serif'
        },
        card: {
            backgroundColor: 'white',
            padding: '50px 40px',
            borderRadius: '30px',
            boxShadow: '0 20px 50px rgba(0,0,0,0.05)',
            maxWidth: '500px',
            width: '100%',
            animation: 'fadeIn 0.8s ease-out'
        },
        logo: {
            width: '110px',
            height: '110px',
            marginBottom: '25px',
            filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.1))'
        },
        welcomeText: {
            fontSize: '13px',
            fontWeight: '700',
            color: '#f97316',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            marginBottom: '10px'
        },
        nameText: {
            fontSize: '30px',
            fontWeight: '800',
            color: '#1e293b',
            marginBottom: '10px'
        },
        roleBadge: {
            display: 'inline-block',
            padding: '4px 12px',
            backgroundColor: userRole === 'admin' ? '#fee2e2' : '#e0f2fe',
            color: userRole === 'admin' ? '#991b1b' : '#075985',
            borderRadius: '20px',
            fontSize: '11px',
            fontWeight: '700',
            textTransform: 'uppercase',
            marginBottom: '20px'
        },
        subText: {
            color: '#64748b',
            lineHeight: '1.6',
            marginBottom: '35px',
            fontSize: '15px'
        },
        buttonGrid: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px'
        },
        mainBtn: {
            gridColumn: 'span 2',
            backgroundColor: '#1e293b',
            color: 'white',
            padding: '16px',
            borderRadius: '14px',
            border: 'none',
            fontWeight: '700',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: '0.3s',
            marginBottom: '5px'
        },
        adminBtn: {
            gridColumn: 'span 2',
            backgroundColor: '#4318FF', // Premium Blue for Admin
            color: 'white',
            padding: '16px',
            borderRadius: '14px',
            border: 'none',
            fontWeight: '700',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: '0.3s',
            marginTop: '5px',
            boxShadow: '0 10px 20px rgba(67, 24, 255, 0.15)'
        },
        actionBtn: {
            backgroundColor: '#f1f5f9',
            color: '#475569',
            padding: '14px',
            borderRadius: '14px',
            border: 'none',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: '0.2s'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <img src={Logo} alt="Muthiah Cotton" style={styles.logo} />

                <p style={styles.welcomeText}>Welcome Back</p>
                <h1 className='text-capitalize' style={styles.nameText}>{userName}</h1>
                <div style={styles.roleBadge}>{userRole}</div>

                <p style={styles.subText}>
                    The system is ready. <br />
                    Select an action below to manage {userRole === 'admin' ? 'the mill' : "today's"} operations.
                </p>

                <div style={styles.buttonGrid}>
                    {/* Common Action for both */}
                    <button
                        style={styles.mainBtn}
                        onClick={() => navigate('/invoices/add')}
                        onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                    >
                        Create New Invoice <FiPlusCircle />
                    </button>

                    <button style={styles.actionBtn} onClick={() => navigate('/purchases')}>
                        <FiShoppingBag /> Purchases
                    </button>

                    <button style={styles.actionBtn} onClick={() => navigate('/farmers')}>
                        <FiBarChart2 /> Farmers
                    </button>

                    {/* ✅ Admin-ku mattum theriyura special button */}
                    {userRole === 'admin' && (
                        <button
                            style={styles.adminBtn}
                            onClick={() => navigate('/dashboard')}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#3311CC'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#4318FF'}
                        >
                            View Analytics Dashboard <FiGrid />
                        </button>
                    )}
                </div>

                <p style={{ marginTop: '30px', fontSize: '11px', color: '#cbd5e1', fontWeight: '500' }}>
                    Muthiah Cotton Mill v2.0 • Secured Access
                </p>
            </div>

            <style>
                {`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    button:active { transform: scale(0.98) !important; }
                `}
            </style>
        </div>
    );
};

export default StaffWelcome;